module.exports = __webpack_public_path__ + "img/favicon.d4261c79.png";